import { skipToken, useSuspenseQuery } from '@apollo/client';

import { DISCOVER_NEIGHBORHOODS } from '../graphql/DISCOVER_NEIGHBORHOODS';
import { View } from '../../../base-components';
import { CustomCheckbox } from '../../../custom-components';

import styles from '../styles';
import DiscoverFilterBoundary from '../DiscoverFilterBoundary/DiscoverFilterBoundary';

export type NeighborhoodFilterProps = {
  onPress?: (id: string) => void;
  cityName?: string;
  selectedNeighborhoodIds?: string[];
  isRental?: boolean;
};

const NeighborhoodFilter = ({
  onPress,
  cityName,
  isRental,
  selectedNeighborhoodIds = [],
}: NeighborhoodFilterProps) => {
  const { data } = useSuspenseQuery(
    DISCOVER_NEIGHBORHOODS,
    cityName
      ? {
          fetchPolicy: 'cache-and-network',
          variables: {
            where: {
              organizationByOrganization: { name: { _eq: cityName } },
              venues: {
                ...(isRental
                  ? {
                      rentals: {
                        is_discoverable: { _eq: true },
                        timeslots: {
                          start_time: { _gt: 'now()' },
                          reservation: { _is_null: true },
                        },
                      },
                    }
                  : {
                      leagues: {
                        status: { _eq: 'registration_open' },
                        archived: { _eq: false },
                        private: { _eq: false },
                      },
                    }),
              },
            },
          },
        }
      : skipToken
  );

  return (
    <View style={styles.container}>
      {data?.neighborhoods.map(({ _id: neighborhoodId, name }) => (
        <CustomCheckbox
          key={neighborhoodId}
          value={neighborhoodId}
          label={name}
          onPress={val => onPress?.(val)}
          checked={selectedNeighborhoodIds.includes(neighborhoodId)}
        />
      ))}
    </View>
  );
};

export default (props: NeighborhoodFilterProps) => (
  <DiscoverFilterBoundary>
    <NeighborhoodFilter {...props} />
  </DiscoverFilterBoundary>
);
